import React from 'react'
import styles from './Key.scss'
import { Icon } from 'common/Icon'
import cx from 'classnames'

export const Key = ({
  tmsKey,
  expanded,
  toggleExpanded
}) => {
  return (
    <div className={styles.Key}>
      <div className={styles.rows}>
        <div className={styles.row}>
          <b>key</b>
          <b>value</b>
          <b>description</b>
          <b>project</b>
        </div>
        <div className={styles.row}>
          <div>{tmsKey.key}</div>
          <div>{tmsKey.value}</div>
          <div>{tmsKey.description}</div>
          <div>{tmsKey.project}</div>
        </div>
      </div>

      {toggleExpanded && <div className={cx(styles.expandArrow, expanded && styles.expandArrowExpanded)} onClick={toggleExpanded}>
        <Icon i='ios-arrow-down' />
      </div>}
    </div>
  )
}
